<form [formGroup]="contactForm">

  <!-- Contact Manager Form -->
  @if (showMainForm) {
    <div fxLayout="column">
      <!--Radio Buttons, Notifications, Menu-->
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <span fxFlex="auto">
          <!-- Dummy div to center the radio buttons -->
        </span>
        <lgd-radio-group fxFlex="30" controlName="contactType" label="Contact Type" [options]="contactTypesObservable" [horizontal]="true">
        </lgd-radio-group>
        <!-- <button mat-button (click)="alertsButtonClicked()" fxLayoutAlign="center start" matTooltip="Alerts"
        style="border-width: 0px;" telemetry="Submission-Alerts">
        <mat-icon>notifications</mat-icon>
        &lt;!-- TODO - this is a funky little input inside a button that is permanently disabled and made to look like a chip.... --&gt;
        &lt;!-- <input telemetry="Edit-AlertCount" class="badge" matInput ng-value="alertCount" [readonly]="!true"
        size="1"> --&gt;
      </button> -->
      <mat-chip-listbox telemetry="Submission-Alerts">
        <mat-chip-option (click)="alertsButtonClicked()" fxLayoutAlign="space-between center">
          <mat-icon>notifications</mat-icon>
          Alerts ({{alertCount}})
        </mat-chip-option>
      </mat-chip-listbox>
      <command-menu [commands]="menuCommands" icon="more_vert">
      </command-menu>
    </div>
    <!--Name and Contact Set-->
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div fxFlex="45" fxLayout="row" fxLayoutAlign="start center">
        <lgd-text #fullName fxFlex controlName="name" label="Name">
        </lgd-text>
        @if (!isCompany) {
          <lgd-checkbox fxFlex="10" controlName="showContactDetails" label="Details">
          </lgd-checkbox>
        }
      </div>
      <lgd-select fxFlex="45" controlName="contactSet" label="Contact Set" placeholder="Contact Set" [options]="contactSetsObservable" aria-label="ContactSet">
      </lgd-select>
    </div>
    <!--Contact Details-->
    @if (isShowContactDetails) {
      <div fxLayout="row" fxLayoutAlign="space-between stretch">
        <lgd-select fxFlex controlName="title" label="Title" placeholder="Title" [options]="titlesObservable">
        </lgd-select>
        <lgd-text fxFlex controlName="firstName" label="First">
        </lgd-text>
        <lgd-text fxFlex controlName="middleName" label="Middle">
        </lgd-text>
        <lgd-text fxFlex controlName="lastName" label="Last">
        </lgd-text>
        <lgd-select fxFlex controlName="suffix" label="Suffix" placeholder="Suffix" [options]="suffixesObservable">
        </lgd-select>
      </div>
    }
    <!--Mailing Address and Primary Phone-->
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div fxFlex="45" fxLayout="row">
        <lgd-select fxFlex="90" controlName="mailingAddress" label="Primary Mailing Address" placeholder="Primary Mailing Address" [options]="mailingAddressesObservable">
        </lgd-select>
        <button mat-icon-button fxFlex (click)="openMailingAddressList()" [matTooltip]="getAddMailingAddressTooltip()" class="mt20" telemetry="Submission-MailingAddressList">
          <mat-icon>{{getAddMailingAddressIcon()}}</mat-icon>
        </button>
      </div>
      <lgd-text fxFlex="45" controlName="phoneNumber" label="Phone Number (Primary)">
      </lgd-text>
    </div>
    <!--Email and Phone 2-->
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div fxFlex="45" fxLayout="row">
        <lgd-text fxFlex controlName="email" label="Email">
        </lgd-text>
        <button mat-icon-button fxFlex="10" (click)="emailContact()" matTooltip="Email Contact" class="mt20" aria-label="Redirect-EmailContact">
          <mat-icon>email</mat-icon>
        </button>
      </div>
      <lgd-text fxFlex="45" controlName="phoneNumber2" label="Phone Number 2">
      </lgd-text>
    </div>
    <!--EIN and Phone 3-->
    <div fxLayout="row" fxLayoutAlign="space-between">
      <lgd-text fxFlex="45" controlName="employerIdentificationNumber" label="Employer Identification Number" telemetry="Edit-EIN" (iconAction)="flipMask(employerIdentificationNumberData)" [iconName]="employerIdentificationNumberData.iconName" [iconTooltip]="employerIdentificationNumberData.tooltipMessage">
      </lgd-text>
      <lgd-text fxFlex="45" controlName="phoneNumber3" label="Phone Number 3" telemetry="Edit-PhoneNumber3">
      </lgd-text>
    </div>
    <!--SSN and DLN-->
    <!--ng-if="true" is needed here to keep mask from breaking-->
    @if (true) {
      <div fxLayout="row" fxLayoutAlign="space-between">
        <lgd-text fxFlex="45" controlName="socialSecurityNumber" label="Social Security Number" telemetry="Edit-SSN" (iconAction)="flipMask(socialSecurityNumberData)" [iconName]="socialSecurityNumberData.iconName" [iconTooltip]="socialSecurityNumberData.tooltipMessage">
        </lgd-text>
        <lgd-text fxFlex="45" controlName="driversLicenseNumber" label="Drivers License Number" telemetry="Edit-DLN" (iconAction)="flipMask(driversLicenseNumberData)" [iconName]="driversLicenseNumberData.iconName" [iconTooltip]="driversLicenseNumberData.tooltipMessage">
        </lgd-text>
      </div>
    }
    <!--Date of Birth, No Check Payment, and Drivers License State-->
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div fxFlex="45" fxLayout="row" fxLayoutAlign="space-between center">
        <lgd-date-picker fxFlex="33" controlName="dateOfBirth" label="DOB" aria-label="DOB">
        </lgd-date-picker>
        <lgd-checkbox fxFlex="33" controlName="isNoCheckPayment" label="No Check Payment" telemetry="Submission-NoCheckPayment">
        </lgd-checkbox>
        <lgd-checkbox fxFlex="33" controlName="isNoCardPayment" label="No Card Payment" telemetry="Submission-NoCardPayment">
        </lgd-checkbox>
      </div>
      <lgd-text fxFlex="45" controlName="driversLicenseState" label="Drivers License State" telemetry="Edit-DLState">
      </lgd-text>
    </div>
  </div>
}

<!-- Alerts -->
@if (showAlerts) {
  <alert-list [alertCodes]="alertCodes" [alerts]="contact.Alerts" [isAdd]="false" [newParentItem]="true" (close)="onAlertsClose($event)" [viewOnly]="isViewOnly">
  </alert-list>
}

<!-- Notes -->
@if (showNotes) {
  <note-list [notes]="contact.Notes" [settings]="notesSettings" [viewOnly]="isViewOnly" (parentCloseBehavior)="notesCloseBehavior(value)">
  </note-list>
}

<!-- Attachments -->
@if (showAttachments) {
  <span>
    @if (!hasTcm) {
      <attachment-list [canEdit]="canEdit" [entityId]="contact.ContactId" [entityType]="entityType" [isAdd]="false" (parentCloseBehavior)="attachmentCloseBehavior()">
      </attachment-list>
    }
    @if (hasTcm) {
      <!-- TODO - WHY ARE WE INLINING A DIALOG COMPONENT HERE????? HOW COULD THAT POSSIBLY WORK OUT? -->
      <tcm-dialog [canEdit]="canEdit" [entityId]="contact.ContactId" [entityType]="entityType" (parentCloseBehavior)="attachmentCloseBehavior()">
      </tcm-dialog>
      <div>
        <div fxFlex="auto"></div>
        <button mat-button (click)="attachmentCloseBehavior()">Close</button>
      </div>
    }
  </span>
}

<!-- UDFs -->
@if (showUserDefinedFields) {
  <user-defined-field-list (onClose)="udfCloseBehavior($event)" [userDefinedFields]="contact.ContactExtensions" [settings]="udfSettings" [viewOnly]="isViewOnly">
  </user-defined-field-list>
}

<!-- Mailing Address List -->
@if (showMailingAddresses) {
  <mailing-address-card parentType="Contact" [mailingAddresses]="contact.MailingAddresses" [usages]="contact.InUseMailingAddresses" [parentId]="contact.ContactId" [viewOnly]="isViewOnly" [isContactNew]="isContactNew" (close)="onMailingAddressClose($event)">
  </mailing-address-card>
}
</form>